
export default [
  {
    name: `instruction_1`,
    title: `Desliza el dedo para realizar un recorrido panorámico.`,
  },
];
